import { render, staticRenderFns } from "./kv-copy-button.vue?vue&type=template&id=3956dde2"
import script from "./kv-copy-button.vue?vue&type=script&lang=js"
export * from "./kv-copy-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports